import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { walldatas } from '../Config/exclusivehandwallcoveringdatas';
import WallCards from "../Components/exclusivehandCards";
import AddToWishlistButton from "../Components/AddToWishlistButton";

const ExclusiveHandsMobile = ({ visibleItems, lastCardRef, cardRefs }) => (
  <div className="overflow-hidden px-2 sm:px-5">
    <div className='services__area pt-10 hidden sm:block' id='services'>
      {/* <h2 className='text-2xl font-serif pl-20 pb-10 underline'>Exclusive Hand Paintings</h2> */}
    </div>
    <div className='grid grid-cols-2 gap-2 max-[640px]:grid-cols-2 justify-items-center'> 
      {walldatas.slice(0, visibleItems).map((it, index) => (
        <div 
          className="w-full max-[640px]:px-1 relative" 
          key={index}
          ref={(el) => {
            if (el) cardRefs.current[index] = el;
          }}
        > 
          <Link to={`/exclusivehand/desc/${parseInt(it.code.replace('#EHP', ''))}`}>
            <WallCards 
              ImgSrc={it.Img} 
              title={it.code} 
              price={it.price} 
              btn={it.btn}
              item={{ ...it, title: it.code || it.title }}
              showWishlistButton={false}
            />
          </Link>
          <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
            <AddToWishlistButton 
              item={{ ...it, title: it.code || it.title }}
              size="small"
            />
          </div>
        </div>
      ))}
    </div>
    {visibleItems < walldatas.length && <div ref={lastCardRef} className="h-1" />}
  </div>
);

const ExclusiveHandsTablet = ({ visibleItems, lastCardRef, cardRefs }) => (
  <div className="overflow-hidden px-3 pt-10">
    <div className='services__area hidden sm:block' id='services'>
      {/* <h2 className='text-xl font-serif pl-10 pb-6 underline'>Exclusive Hand Paintings</h2> */}
    </div>
    <div className='grid grid-cols-2 gap-3 justify-items-center'>
      {walldatas.slice(0, visibleItems).map((it, index) => (
        <div 
          className="w-full max-w-[160px] relative" 
          key={index}
          ref={(el) => {
            if (el) cardRefs.current[index] = el;
          }}
        >
          <Link to={`/exclusivehand/desc/${parseInt(it.code.replace('#EHP', ''))}`}>
            <WallCards 
              ImgSrc={it.Img} 
              title={it.code} 
              price={it.price} 
              btn={it.btn}
              item={{ ...it, title: it.code || it.title }}
              showWishlistButton={false}
            />
          </Link>
          <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
            <AddToWishlistButton 
              item={{ ...it, title: it.code || it.title }}
              size="small"
            />
          </div>
        </div>
      ))}
    </div>
    {visibleItems < walldatas.length && <div ref={lastCardRef} className="h-1" />}
  </div>
);

const ExclusiveHandsMidDesktop = ({ visibleItems, lastCardRef, cardRefs }) => (
  <div className="overflow-hidden px-4 pt-14">
    <div className='services__area hidden sm:block' id='services'>
      {/* <h2 className='text-xl font-serif pl-12 pb-8 underline'>Exclusive Hand Paintings</h2> */}
    </div>
    <div className='grid grid-cols-3 gap-4 justify-items-center'>
      {walldatas.slice(0, visibleItems).map((it, index) => (
        <div 
          className="w-full max-w-[260px] relative" 
          key={index}
          ref={(el) => {
            if (el) cardRefs.current[index] = el;
          }}
        > 
          <Link to={`/exclusivehand/desc/${parseInt(it.code.replace('#EHP', ''))}`}>
            <WallCards 
              ImgSrc={it.Img}
              title={it.code}
              price={it.price}
              btn={it.btn}
              customStyle="w-full h-[180px] object-cover scale-105"
              item={{ ...it, title: it.code || it.title }}
              showWishlistButton={false}
            />
          </Link>
          <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
            <AddToWishlistButton 
              item={{ ...it, title: it.code || it.title }}
              size="small"
            />
          </div>
        </div>
      ))}
    </div>
    {visibleItems < walldatas.length && <div ref={lastCardRef} className="h-1" />}
  </div>
);

const ExclusiveHandsLaptop = ({ visibleItems, lastCardRef, cardRefs }) => (
  <div className="overflow-hidden p-0 sm:p-5 pt-20">
    <div className='services__area pt-10 hidden sm:block' id='services'>
      {/* <h2 className='text-xl font-serif pl-20 pb-10 underline'>Exclusive Hand Paintings</h2> */}
    </div>
    <div className='grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-10  justify-items-center max-w-[1300px] mx-auto px-4'> 
      {walldatas.slice(0, visibleItems).map((it, index) => (
        <div 
          className="w-full sm:w-auto relative" 
          key={index}
          ref={(el) => {
            if (el) cardRefs.current[index] = el;
          }}
        > 
          <Link to={`/exclusivehand/desc/${parseInt(it.code.replace('#EHP', ''))}`}>
            <WallCards 
              ImgSrc={it.Img} 
              title={it.code} 
              price={it.price} 
              btn={it.btn}
              item={{ ...it, title: it.code || it.title }}
              showWishlistButton={false}
            />
          </Link>
          <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
            <AddToWishlistButton 
              item={{ ...it, title: it.code || it.title }}
              size="small"
            />
          </div>
        </div>
      ))}
    </div>
    {visibleItems < walldatas.length && <div ref={lastCardRef} className="h-1" />}
  </div>
);

const ExclusiveHands = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const scrollToId = searchParams.get('scrollTo');
  
  console.log('[ExclusiveHands] Component rendered - scrollToId from URL:', scrollToId, 'Full URL:', location.pathname + location.search);
  
  // Always prioritize sessionStorage over URL parameter (sessionStorage has the latest viewed image)
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    const lastViewedId = sessionStorage.getItem('lastViewedImageIdExclusivehandpainting');
    
    console.log('[ExclusiveHands] Checking - scrollToId in URL:', currentScrollToId, 'lastViewedId in storage:', lastViewedId);
    
    // Always prioritize sessionStorage if it exists (it has the most recent viewed image)
    if (lastViewedId) {
      // If URL has a different scrollToId than sessionStorage, update URL to use sessionStorage value
      if (currentScrollToId !== lastViewedId) {
        console.log('[ExclusiveHands] sessionStorage has different value than URL. Updating URL to use latest:', lastViewedId);
        const newSearchParams = new URLSearchParams(location.search);
        newSearchParams.set('scrollTo', lastViewedId);
        navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
        // Clear sessionStorage after using it
        sessionStorage.removeItem('lastViewedImageIdExclusivehandpainting');
        console.log('[ExclusiveHands] Updated URL with scrollTo from sessionStorage and cleared sessionStorage');
      } else {
        // They match, so clear sessionStorage to avoid conflicts
        console.log('[ExclusiveHands] URL and sessionStorage match, clearing sessionStorage');
        sessionStorage.removeItem('lastViewedImageIdExclusivehandpainting');
      }
    } else if (currentScrollToId) {
      // No sessionStorage but URL has scrollToId - this is fine, just log it
      console.log('[ExclusiveHands] Using scrollToId from URL:', currentScrollToId);
    } else {
      // Neither exists - normal navigation without scroll
      console.log('[ExclusiveHands] No scrollToId in URL and no lastViewedId in storage');
    }
  }, [location.pathname, location.search, navigate]);
  
  const [visibleItems, setVisibleItems] = useState(20);
  const [screenType, setScreenType] = useState('mobile');
  const [hasScrolledToTarget, setHasScrolledToTarget] = useState(false);
  const observer = useRef();
  const cardRefs = useRef({});

  // Reset scroll state when scrollToId changes
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    if (currentScrollToId) {
      console.log('[ExclusiveHands] scrollToId changed, resetting hasScrolledToTarget');
      setHasScrolledToTarget(false);
    }
  }, [location.search]);

  const lastCardRef = useCallback(node => {
    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && visibleItems < walldatas.length) {
        setVisibleItems(prev => Math.min(prev + 20, walldatas.length));
      }
    }, {
      rootMargin: '400px 0px',
    });
    if (node) {
      observer.current.observe(node);
    }
  }, [visibleItems]);

  // Handle scrolling to target image - direct scroll without transition
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    console.log('[ExclusiveHands] Scroll effect triggered - scrollToId:', currentScrollToId, 'hasScrolledToTarget:', hasScrolledToTarget, 'visibleItems:', visibleItems);
    
    if (currentScrollToId && !hasScrolledToTarget) {
      // Find the item with the matching EHP code
      const targetEHPCode = `#EHP${String(parseInt(currentScrollToId)).padStart(3, '0')}`;
      const targetIndex = walldatas.findIndex(item => item.code === targetEHPCode);
      
      console.log('[ExclusiveHands] Target EHP code:', targetEHPCode, 'Target index:', targetIndex);
      
      if (targetIndex === -1) {
        // If not found, try using the index directly
        const fallbackIndex = parseInt(currentScrollToId) - 1;
        console.log('[ExclusiveHands] EHP code not found, trying fallback index:', fallbackIndex);
        
        if (fallbackIndex >= 0 && fallbackIndex < walldatas.length) {
          // Ensure enough items are loaded to include the target
          if (fallbackIndex >= visibleItems) {
            const newVisibleItems = Math.max(visibleItems, fallbackIndex + 10);
            console.log('[ExclusiveHands] Not enough items loaded. Current:', visibleItems, 'Target index:', fallbackIndex, 'Loading more:', newVisibleItems);
            setVisibleItems(newVisibleItems);
            return;
          }
          
          const timer = setTimeout(() => {
            console.log('[ExclusiveHands] Fallback scroll attempt');
            const targetElement = cardRefs.current[fallbackIndex];
            console.log('[ExclusiveHands] Target element found:', !!targetElement);
            
            if (targetElement) {
              console.log('[ExclusiveHands] Scrolling to element');
              targetElement.scrollIntoView({
                behavior: 'auto',
                block: 'center'
              });
              setHasScrolledToTarget(true);
              console.log('[ExclusiveHands] Scroll completed successfully');
            }
          }, 100);
          
          return () => {
            console.log('[ExclusiveHands] Cleaning up fallback scroll timeout');
            clearTimeout(timer);
          };
        }
        console.log('[ExclusiveHands] Fallback index out of bounds');
        return;
      }
      
      // Ensure enough items are loaded to include the target
      if (targetIndex >= visibleItems) {
        const newVisibleItems = Math.max(visibleItems, targetIndex + 10);
        console.log('[ExclusiveHands] Not enough items loaded. Current:', visibleItems, 'Target index:', targetIndex, 'Loading more:', newVisibleItems);
        setVisibleItems(newVisibleItems);
        return;
      }
      
      // Multiple attempts to scroll with increasing delays for mobile reliability
      const attemptScroll = (attempt = 1) => {
        console.log(`[ExclusiveHands] Attempt ${attempt} to scroll to index:`, targetIndex);
        const targetElement = cardRefs.current[targetIndex];
        console.log('[ExclusiveHands] Target element found:', !!targetElement);
        
        if (targetElement) {
          console.log('[ExclusiveHands] Scrolling to element');
          targetElement.scrollIntoView({
            behavior: 'auto', // Direct scroll without transition
            block: 'center'
          });
          setHasScrolledToTarget(true);
          console.log('[ExclusiveHands] Scroll completed successfully');
          return true;
        }
        console.log('[ExclusiveHands] Target element not found, will retry');
        return false;
      };

      // First attempt after 200ms
      const timer1 = setTimeout(() => {
        console.log('[ExclusiveHands] First scroll attempt');
        if (!attemptScroll(1)) {
          // Second attempt after 400ms
          setTimeout(() => {
            console.log('[ExclusiveHands] Second scroll attempt');
            if (!attemptScroll(2)) {
              // Third attempt after 600ms
              setTimeout(() => {
                console.log('[ExclusiveHands] Third scroll attempt');
                if (!attemptScroll(3)) {
                  // Final attempt after 800ms
                  setTimeout(() => {
                    console.log('[ExclusiveHands] Final scroll attempt');
                    attemptScroll(4);
                  }, 200);
                }
              }, 200);
            }
          }, 200);
        }
      }, 200); // Increased initial timeout for mobile
      
      return () => {
        console.log('[ExclusiveHands] Cleaning up scroll timeout');
        clearTimeout(timer1);
      };
    }
  }, [location.search, hasScrolledToTarget, visibleItems]);

  useEffect(() => {
    const updateScreenType = () => {
      const width = window.innerWidth;
      if (width <= 635) {
        setScreenType('mobile');
      } else if (width >= 636 && width <= 788) {
        setScreenType('tablet');
      } else if (width >= 800 && width <= 1244) {
        setScreenType('mid-desktop');
      } else {
        setScreenType('laptop');
      }
    };

    updateScreenType();
    window.addEventListener('resize', updateScreenType);
    return () => window.removeEventListener('resize', updateScreenType);
  }, []);

  if (screenType === 'tablet') return <ExclusiveHandsTablet visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
  if (screenType === 'mid-desktop') return <ExclusiveHandsMidDesktop visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
  if (screenType === 'laptop') return <ExclusiveHandsLaptop visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
  return <ExclusiveHandsMobile visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
};

export default ExclusiveHands;
  











// import React from 'react';
// import { Link } from 'react-router-dom';
// import { walldatas } from '../Config/exclusivehandwallcoveringdatas';
// import WallCards from "../Components/exclusivehandCards";

// const ExclusiveHands = () => {
//   return (
//     <div className="overflow-hidden p-0 sm:p-5 z-10">

// <div className='services__area pt-10 hidden sm:block' id='services'>
//   <h2 className='text-xl font-serif pl-20 pb-10 underline'>Exclusive Hand Paintings</h2>
// </div>

      
//        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center'> {/* Adjusted gap for uniform spacing */}
//         {walldatas.map((it, index) => (
//           <div className="flex justify-center pl-5 pr-5 w-full" key={index}> {/* Center the card in its grid cell */}
//            <Link to={`/wallcoverings/exclusivehand/desc/${index + 1}`}>
//             <WallCards 
//                ImgSrc={it.Img} 
//                title={it.title} 
//                desc={it.desc} 
//                btn={it.btn} 
//             />
//             </Link>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default ExclusiveHands;















// import React from 'react';
// import { Link } from 'react-router-dom';
// import { walldata } from '../Config/wallcoveringdata'; // Assuming you have the data in this file

// const Wallcoverings = () => {
//   return (
//     <div className="overflow-hidden p-0 sm:p-5">
//       <div className='services__area pt-10 hidden sm:block' id='services'>
//         <h2 className='text-xl font-serif pl-20 pb-10 underline'>Nature Wallpapers</h2>
//       </div>

//       <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center'>
//         {walldata.map((item, index) => (
//           <div className="relative group w-full h-full" key={index}>
//             {/* Link to the corresponding image's description page using its index */}
//             <Link to={`/wallcoverings/nature/desc/${index + 1}`}>
//               {/* Image with hover effect */}
//               <img
//                 src={item.Img}
//                 alt={item.title}
//                 className="w-full h-auto object-cover transition-transform duration-300 ease-in-out group-hover:scale-105" // Scale up on hover
//               />
//               {/* Hover effect and title display */}
//               <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white p-2 text-center transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100">
//                 {item.title}
//               </div>
//             </Link>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Wallcoverings;
